"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChatProvider = createChatProvider;
const react_1 = __importStar(require("react"));
// Do not change the useScrollLock import from "../hooks/useScrollLock" to a "../hooks". As it will create a circular dependency issue.
const useScrollLock_1 = require("../hooks/useScrollLock");
const OrganizationContext_1 = require("./OrganizationContext");
function createChatProvider(Context, config) {
    return function ChatProvider({ children }) {
        const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
        const chatManager = config.getChatManager(selectedOrgUser);
        const [isChatLoading, setIsChatLoading] = (0, react_1.useState)(false);
        const { concurrencySafe } = (0, useScrollLock_1.useScrollLock)();
        const chats = chatManager === null || chatManager === void 0 ? void 0 : chatManager.getChats();
        const [reactiveChatData, setReactiveChatData] = (0, react_1.useState)(chats ? { chatData: chats } : undefined);
        (0, react_1.useEffect)(() => {
            let removeChangeListener;
            if (chatManager) {
                removeChangeListener = chatManager.registerChangeListener((chatsData) => {
                    setReactiveChatData(() => ({
                        chatData: chatsData,
                    }));
                });
            }
            return () => {
                if (removeChangeListener) {
                    removeChangeListener();
                }
            };
        }, [chatManager]);
        const setChatData = (chatData) => {
            setReactiveChatData(() => chatData ? { chatData: chatData } : undefined);
        };
        const fetchChats = () => __awaiter(this, void 0, void 0, function* () {
            if ((!reactiveChatData || reactiveChatData.chatData.hasNext) &&
                chatManager) {
                yield concurrencySafe(() => __awaiter(this, void 0, void 0, function* () {
                    setIsChatLoading(true);
                    yield chatManager.fetchChats();
                    setIsChatLoading(false);
                }));
            }
        });
        const getChats = () => {
            if ((!reactiveChatData || reactiveChatData.chatData.hasNext) &&
                chatManager &&
                chatManager.getChats) {
                setIsChatLoading(true);
                setChatData(chatManager.getChats());
                setIsChatLoading(false);
            }
        };
        const contextValue = {
            chatData: reactiveChatData === null || reactiveChatData === void 0 ? void 0 : reactiveChatData.chatData,
            setChatData,
            isChatLoading,
            fetchChats,
            getChats,
        };
        return react_1.default.createElement(Context.Provider, { value: contextValue }, children);
    };
}
